
import { Component, Vue } from 'vue-property-decorator'
import { CommonService } from '@/services'
import { ElForm } from 'element-ui/types/form'
import { isValidURL } from '@/common/utils'
import UploadImg from '@/common/class/UploadImg'

const typeMap = {
    normal: {
        key: 1, name: '非媒体人'
    },
    media: {
        key: 2, name: '媒体人'
    }
}

@Component({})
export default class Activity extends Vue {
    private activityForm: any = { banner: '', page_url: '', is_show: false }
    private uploadImgUrl: any = ''
    private imgFile?: File
    private isLoading = false
    private loadingMsg = '加载数据中'
    private previewSrc = ''
    private imgLoad = false
    private copy: any = ''
    private typeMap = typeMap
    private curType = typeMap.normal.key
    private activityRules: any = {
        banner: [
            { required: true, validator: this.bannerValidator }
        ],
        page_url: [
            { validator: this.pageUrlValidator }
        ]
    }

    get activityFormRef() {
        return (this.$refs.activityForm as ElForm)
    }

    async mounted() {
        this.getActivityData()
    }

    bannerValidator(rule: any, value: any, callback: Function) {
        if (this.activityForm.banner) callback()
        if (!this.imgFile) {
            return callback('请选择上传图片')
        }
        callback()
    }

    onfileSelect() {
        (this.$refs.file as HTMLElement).click()
    }

    pageUrlValidator(rule: any, value: string, callback: Function) {
        let message = '请输入正确的链接地址'
        if (!value) return callback()
        if (!isValidURL(value)) {
            return callback(message)
        }
        callback()
    }

    async getActivityData() {
        this.showLoading()
        const result = await CommonService.getMediaIndexBanner({ type: this.curType })
        this.hideLoading()
        if (result.status === 200) {
            this.uploadImgUrl = result.data.banner
            this.copy = JSON.stringify(result.data)
            this.activityForm = result.data
        }
    }

    onFileChange(e: Event) {
        const file = (e.target as any).files[0] 
        this.imgFile = file
        this.previewSrc = URL.createObjectURL(file)
        this.activityForm.banner = this.previewSrc
        this.activityFormRef.validateField('img')
    }

    async onSaveForm() {
        this.activityFormRef.validate(async (isValid: boolean) => {
            if (!isValid) return

            const isUpdate = this._hasUpdate()
            if (!isUpdate) {
                return this.$message({ 
                    type: 'warning', 
                    message: '请修改后再保存' 
                })
            }

            if (this.imgFile) {
                const key = await this.uploadImg()
                if (!key) {
                    return this.$message({ 
                        type: 'warning', 
                        message: '上传图片发生错误, 请稍后再试' 
                    })
                }
                this.activityForm.banner = key
            }
            this.showLoading('修改中')
            const params = { type: this.curType, ...this.activityForm }
            const result = await CommonService.updateMediaIndexBanner(params)
            this.hideLoading()
            if (result.status === 200) {
                this.$message({ type: 'success', message: '保存成功' })
                this.getActivityData()
            }
        })
    }

    async uploadImg() {
        let uploadimg
        if (!this.imgFile) {
            this.$message({ type: 'warning', message: '发生错误, 请稍后再试' })    
            return false
        }
        // 修改了图片
        uploadimg = new UploadImg(this.imgFile)
        this.showLoading('上传图片中')
        const uploadRes: any = await uploadimg.upload()
        if (uploadRes.error) {
            this.$message({ type: 'warning', message: '图片上传失败, 请稍后再试' })
            return false
        }
        return uploadRes.key
    }

    showLoading(msg = '') {
        if (msg) {
            this.loadingMsg = msg
        }
        this.isLoading = true
    }

    hideLoading() {
        this.isLoading = false
    }

    _hasUpdate() {
        const originForm = JSON.parse(this.copy)
        for (let key in originForm) {
            if (originForm[key] !== this.activityForm[key]) {
                return true
            }
        }
        return false
    }

    async onChangeType() {
        this.showLoading()
        await this.getActivityData()
        this.hideLoading()
    }
}
